<h4 *ngIf="notification?.timeLabel" class="notification-sub-cat">
  {{ notification?.timeLabel | translate | uppercase }}
</h4>
<ui-card
  class="
    notification
    d-flex
    align-items-center
    justify-content-between
    position-relative
    cursor-pointer
  "
  [ngClass]="{
    'notification--read': !(notification?.createdAt | checkNew: lastViewed)
  }"
>
  <div class="d-sm-flex align-items-center justify-content-between notification-text h-100">
    <div class="notification-user cml-8" (click)="open()">
      <app-profile-photo
        width="44"
        [user]="notification?.content?.message_id?.author"
      ></app-profile-photo>
      <span
        class="notification-type-ico d-flex justify-content-center align-items-center"
        [ngClass]="{
          comment: notification?.type === 'COMMENT'
        }"
      >
        <ng-container [ngSwitch]="notification?.type">
          <mat-icon *ngSwitchCase="'COMMENT'">alternate_email</mat-icon>
        </ng-container>
      </span>
    </div>
    <div
      class="
        content-wrap
        d-sm-flex
        align-items-center
        justify-content-between
        notification-text
        h-100
      "
    >
      <div *ngIf="notification" class="notification-content" (click)="open()">
        <ng-container
          *ngFor="let msgContent of notification.content?.message_id?.content; let i = index"
          [ngSwitch]="msgContent.type"
        >
          <ui-fragment
            *ngSwitchCase="MessageContentType.Text"
            [fragment]="notification.content?.message_id?.content[i]"
            [replaceEquations]="true"
          >
          </ui-fragment>
          <p *ngSwitchCase="MessageContentType.Image">{{ 'Sent an image.' | translate }}</p>
          <p *ngSwitchCase="MessageContentType.Video">{{ 'Sent a video.' | translate }}</p>
          <p *ngSwitchCase="MessageContentType.Equation">{{ 'Sent an equation.' | translate }}</p>
          <p *ngSwitchDefault>{{ 'Sent an attachment.' | translate }}</p>
        </ng-container>
      </div>
      <div class="notification-time" (click)="open()">
        <span class="dot cmr-4" *ngIf="notification?.createdAt | checkNew: lastViewed"></span>
        {{ notification?.createdAt | notificationTime }}
      </div>
      <div
        class="cpr-24 align-items-center notification-menu"
        [ngClass]="{ 'notification-menu--open': isMenuOpened }"
      >
        <i
          class="material-icons menu-icon"
          [matMenuTriggerFor]="questionMenu"
          [class.active]="isMenuOpened"
          (menuOpened)="isMenuOpened = true"
          (menuClosed)="isMenuOpened = false"
          >more_horiz</i
        >
        <mat-menu #questionMenu="matMenu">
          <button
            mat-menu-item
            (click)="closeNotification.emit(notification?._id)"
            class="archive-btn"
          >
            <i class="material-icons-outlined menu-list-icon">archive</i
            >{{ 'Archive notification' | translate }}
          </button>
        </mat-menu>
      </div>
    </div>
  </div>
</ui-card>
